// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AYvd","type":"styles_type__dOb69","choices":"styles_choices__1QitF"};